export const MOTIF_LABELS: Record<string, string> = {
  blunder: "Blunders",
  mistake: "Mistakes",
  imprecision: "Inaccuracies",
  time_pressure: "Time pressure",
  low_time: "Low time",
  opening_phase: "Opening phase",
  endgame_phase: "Endgame phase",
  missed_check: "Missed checks",
  missed_capture: "Missed captures",
  hanging_piece: "Hanging pieces",
  fork: "Forks",
  pin: "Pins",
  skewer: "Skewers",
  discovered_attack: "Discovered attacks",
  back_rank_threat: "Back-rank tactics",
  deflection: "Deflections",
  sacrifice: "Sacrifices",
  zwischenzug: "Zwischenzugs",
  mating_net: "Mating nets",
  overloaded_defender: "Overloaded defenders",
};
